// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#canvas-container{width:70%;height:100;position:absolute;z-index:-1;top:0;left:30%;right:0;bottom:0}", ""]);
// Exports
module.exports = exports;
